import { render } from "./shareoffcanvas.vue?vue&type=template&id=3c887926"
import script from "./shareoffcanvas.vue?vue&type=script&lang=js"
export * from "./shareoffcanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__